// 가족관계 코드
export const familyType = (type: string) => {
  let famType = '';
  switch (type) {
    case '0':
      famType = '본인';
      break;
    case '1':
      famType = '소득자 직계존속';
      break;
    case '2':
      famType = '배우자 직계존속';
      break;
    case '3':
      famType = '배우자';
      break;
    case '4':
      famType = '직계비속 자녀.입양자';
      break;
    case '5':
      famType = '직계비속 기타';
      break;
    case '6':
      famType = '형제자매';
      break;
    case '7':
      famType = '수급자';
      break;
    case '8':
      famType = '위탁아동';
      break;
    default:
      famType = '';
  }
  return famType;
};

export const familySelect = (type: string) => {
  const options = [
    { id: '0', value: '본인' },
    { id: '1', value: '소득자 직계존속' },
    { id: '2', value: '배우자 직계존속' },
    { id: '3', value: '배우자' },
    { id: '4', value: '직계비속 자녀.입양자' },
    { id: '5', value: '직계비속 기타' },
    { id: '6', value: '형제자매' },
    { id: '7', value: '수급자' },
    { id: '8', value: '위탁아동' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[0];
  return { checked: findItem, options };
};

export const siblingsSelect = (type: string) => {
  const options = [
    { id: '0', value: '형' },
    { id: '1', value: '제' },
    { id: '2', value: '누나(언니)' },
    { id: '3', value: '매' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[0];
  return { checked: findItem, options };
};

export const childSelect = (type: string) => {
  // 0:미입력,1:첫째,2:둘째,3:셋째이상
  const options = [
    { id: '0', value: '미입력' },
    { id: '1', value: '첫째' },
    { id: '2', value: '둘째' },
    { id: '3', value: '셋째이상' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[0];
  return { checked: findItem, options };
};

// 장애인 코드
export const isHandyType = (type: string) => {
  let famType = '';
  switch (type) {
    case '0':
      famType = '비장애인';
      break;
    case '1':
      famType = '장애인복지법에 따른 장애인';
      break;
    case '2':
      famType = '국가유공자등 예우및 지원에 따른 장애인';
      break;
    case '3':
      famType = '항시치료를 요하는 중증환자';
      break;
    default:
      famType = '비장애인';
  }
  return famType;
};
export const isHandySelect = (type: string) => {
  const options = [
    { id: '0', value: '비장애인' },
    { id: '1', value: '장애인복지법에 따른 장애인' },
    { id: '2', value: '국가유공자등 예우및 지원에 따른 장애인' },
    { id: '3', value: '항시치료를 요하는 중증환자' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[0];
  return { checked: findItem, options };
};

// 자녀 코드
export const isChildType = (type: string) => {
  let famType = '';
  switch (type) {
    case '0':
      famType = '미입력';
      break;
    case '1':
      famType = '첫째';
      break;
    case '2':
      famType = '둘째';
      break;
    case '3':
      famType = '셋째이상';
      break;
    default:
      famType = '미입력';
  }
  return famType;
};

// 대상여부
export const isTargetType = (type: string) => {
  let famType = '';
  switch (type) {
    case 'Y':
      famType = '대상';
      break;
    default:
      famType = '비대상';
  }
  return famType;
};
export const isTargetSelect = (type: string) => {
  const options = [
    { id: 'Y', value: '대상' },
    { id: 'N', value: '비대상' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

// 대상여부
export const isYNType = (type: string) => {
  let famType = '';
  switch (type) {
    case 'Y':
      famType = '네';
      break;
    default:
      famType = '아니오';
  }
  return famType;
};

export const isYNSelect = (type: any) => {
  const options = [
    { id: 'Y', value: '네' },
    { id: 'N', value: '아니오' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

// 대상여부
export const isFullType = (type: string) => {
  let famType = '';
  switch (type) {
    case 'Y':
      famType = '충족';
      break;
    default:
      famType = '불충족';
  }
  return famType;
};

export const isFullSelect = (type: string) => {
  const options = [
    { id: 'Y', value: '충족' },
    { id: 'N', value: '불충족' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

export const workTypeSelect = (type: string) => {
  const options = [
    { id: 'Y', value: '게속근로' },
    { id: 'N', value: '중도퇴사' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

export const isSexSelect = (type: any) => {
  const options = [
    { id: '1', value: '남' },
    { id: '2', value: '여' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

export const isResidentialSelect = (type: any) => {
  const options = [
    { id: 'Y', value: '거주' },
    { id: 'N', value: '비거주' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

export const isWorkSelect = (type: any) => {
  const options = [
    { id: '1', value: '납세조합' },
    { id: '2', value: '종(전)근무지' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};

// 제출서류 상위분류 설명문구 (코드값 임의 작성)
export const submitDocDescType = (code: string) => {
  let desc = '';
  switch (code) {
    case '10':
      desc = '신용카드 등 사용금액을 확인하기 위한 서류입니다.';
      break;
    case '20':
      desc = '보장성 보험료의 납입액을 확인하기 위한 서류입니다.';
      break;
    case '30':
      desc = '의료비 지출액을 확인하기 위한 서류입니다.';
      break;
    case '40':
      desc = '교육비 지출액을 확인하기 위한 서류입니다.';
      break;
    case '50':
      desc = '기부금 공제 신청 금액을 확인하기 위한 서류입니다.';
      break;
    case '60':
      desc = '주택자금 공제를 확인하기 위한 서류입니다.';
      break;
    case '70':
      desc = '연금계좌 납입액을 확인하기 위한 서류입니다.';
      break;
    default:
      desc = '해당 항목의 공제 내용을 확인하기 위한 서류입니다.';
  }
  return desc;
};

export const isDonationSelect = (type: any) => {
  const options = [
    { id: '41', value: '일반기부금(종교단체)' },
    { id: '42', value: '우리사주조합기부금' },
    { id: '43', value: '고향사랑기부금' },
    // { id: '50', value: '지정기부금' },
  ];
  let findItem = options.find((item: any) => item.id === type);
  if (!findItem) findItem = options[1];
  return { checked: findItem, options };
};
